/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "uXl7");
/******/ })
/************************************************************************/
/******/ ({

/***/ "21It":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var createError = __webpack_require__("FtD3");

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */
module.exports = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  if (!response.status || !validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(createError('Request failed with status code ' + response.status, response.config, null, response.request, response));
  }
};

/***/ }),

/***/ "5VQ+":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("cGG2");

module.exports = function normalizeHeaderName(headers, normalizedName) {
  utils.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};

/***/ }),

/***/ "7GwW":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("cGG2");
var settle = __webpack_require__("21It");
var cookies = __webpack_require__("p1b6");
var buildURL = __webpack_require__("DQCr");
var buildFullPath = __webpack_require__("Oi+a");
var parseHeaders = __webpack_require__("oJlt");
var isURLSameOrigin = __webpack_require__("GHBc");
var createError = __webpack_require__("FtD3");

module.exports = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;

    if (utils.isFormData(requestData)) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest();

    // HTTP basic authentication
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    var fullPath = buildFullPath(config.baseURL, config.url);
    request.open(config.method.toUpperCase(), buildURL(fullPath, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    // Listen for ready state
    request.onreadystatechange = function handleLoad() {
      if (!request || request.readyState !== 4) {
        return;
      }

      // The request errored out and we didn't get a response, this will be
      // handled by onerror instead
      // With one exception: request that using file: protocol, most browsers
      // will return status as 0 even though it's a successful request
      if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
        return;
      }

      // Prepare the response
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
      var response = {
        data: responseData,
        status: request.status,
        statusText: request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };

      settle(resolve, reject, response);

      // Clean up request
      request = null;
    };

    // Handle browser request cancellation (as opposed to a manual cancellation)
    request.onabort = function handleAbort() {
      if (!request) {
        return;
      }

      reject(createError('Request aborted', config, 'ECONNABORTED', request));

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(createError('Network Error', config, null, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      var timeoutErrorMessage = 'timeout of ' + config.timeout + 'ms exceeded';
      if (config.timeoutErrorMessage) {
        timeoutErrorMessage = config.timeoutErrorMessage;
      }
      reject(createError(timeoutErrorMessage, config, 'ECONNABORTED', request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (utils.isStandardBrowserEnv()) {
      // Add xsrf header
      var xsrfValue = (config.withCredentials || isURLSameOrigin(fullPath)) && config.xsrfCookieName ? cookies.read(config.xsrfCookieName) : undefined;

      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    }

    // Add withCredentials to request if needed
    if (!utils.isUndefined(config.withCredentials)) {
      request.withCredentials = !!config.withCredentials;
    }

    // Add responseType to request if needed
    if (config.responseType) {
      try {
        request.responseType = config.responseType;
      } catch (e) {
        // Expected DOMException thrown by browsers not compatible XMLHttpRequest Level 2.
        // But, this can be suppressed for 'json' type as it can be parsed by default 'transformResponse' function.
        if (config.responseType !== 'json') {
          throw e;
        }
      }
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken) {
      // Handle cancellation
      config.cancelToken.promise.then(function onCanceled(cancel) {
        if (!request) {
          return;
        }

        request.abort();
        reject(cancel);
        // Clean up request
        request = null;
      });
    }

    if (!requestData) {
      requestData = null;
    }

    // Send the request
    request.send(requestData);
  });
};

/***/ }),

/***/ "DQCr":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("cGG2");

function encode(val) {
  return encodeURIComponent(val).replace(/%3A/gi, ':').replace(/%24/g, '$').replace(/%2C/gi, ',').replace(/%20/g, '+').replace(/%5B/gi, '[').replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
module.exports = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];

    utils.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils.isArray(val)) {
        key = key + '[]';
      } else {
        val = [val];
      }

      utils.forEach(val, function parseValue(v) {
        if (utils.isDate(v)) {
          v = v.toISOString();
        } else if (utils.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    var hashmarkIndex = url.indexOf('#');
    if (hashmarkIndex !== -1) {
      url = url.slice(0, hashmarkIndex);
    }

    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};

/***/ }),

/***/ "DUeU":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("cGG2");

/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 * @returns {Object} New object resulting from merging config2 to config1
 */
module.exports = function mergeConfig(config1, config2) {
  // eslint-disable-next-line no-param-reassign
  config2 = config2 || {};
  var config = {};

  var valueFromConfig2Keys = ['url', 'method', 'data'];
  var mergeDeepPropertiesKeys = ['headers', 'auth', 'proxy', 'params'];
  var defaultToConfig2Keys = ['baseURL', 'transformRequest', 'transformResponse', 'paramsSerializer', 'timeout', 'timeoutMessage', 'withCredentials', 'adapter', 'responseType', 'xsrfCookieName', 'xsrfHeaderName', 'onUploadProgress', 'onDownloadProgress', 'decompress', 'maxContentLength', 'maxBodyLength', 'maxRedirects', 'transport', 'httpAgent', 'httpsAgent', 'cancelToken', 'socketPath', 'responseEncoding'];
  var directMergeKeys = ['validateStatus'];

  function getMergedValue(target, source) {
    if (utils.isPlainObject(target) && utils.isPlainObject(source)) {
      return utils.merge(target, source);
    } else if (utils.isPlainObject(source)) {
      return utils.merge({}, source);
    } else if (utils.isArray(source)) {
      return source.slice();
    }
    return source;
  }

  function mergeDeepProperties(prop) {
    if (!utils.isUndefined(config2[prop])) {
      config[prop] = getMergedValue(config1[prop], config2[prop]);
    } else if (!utils.isUndefined(config1[prop])) {
      config[prop] = getMergedValue(undefined, config1[prop]);
    }
  }

  utils.forEach(valueFromConfig2Keys, function valueFromConfig2(prop) {
    if (!utils.isUndefined(config2[prop])) {
      config[prop] = getMergedValue(undefined, config2[prop]);
    }
  });

  utils.forEach(mergeDeepPropertiesKeys, mergeDeepProperties);

  utils.forEach(defaultToConfig2Keys, function defaultToConfig2(prop) {
    if (!utils.isUndefined(config2[prop])) {
      config[prop] = getMergedValue(undefined, config2[prop]);
    } else if (!utils.isUndefined(config1[prop])) {
      config[prop] = getMergedValue(undefined, config1[prop]);
    }
  });

  utils.forEach(directMergeKeys, function merge(prop) {
    if (prop in config2) {
      config[prop] = getMergedValue(config1[prop], config2[prop]);
    } else if (prop in config1) {
      config[prop] = getMergedValue(undefined, config1[prop]);
    }
  });

  var axiosKeys = valueFromConfig2Keys.concat(mergeDeepPropertiesKeys).concat(defaultToConfig2Keys).concat(directMergeKeys);

  var otherKeys = Object.keys(config1).concat(Object.keys(config2)).filter(function filterAxiosKeys(key) {
    return axiosKeys.indexOf(key) === -1;
  });

  utils.forEach(otherKeys, mergeDeepProperties);

  return config;
};

/***/ }),

/***/ "EBst":
/***/ (function(module, exports, __webpack_require__) {

!function () {
  "use strict";
  function e(e, t) {
    var n,
        o,
        r,
        i,
        l = W;for (i = arguments.length; i-- > 2;) {
      P.push(arguments[i]);
    }t && null != t.children && (P.length || P.push(t.children), delete t.children);while (P.length) {
      if ((o = P.pop()) && void 0 !== o.pop) for (i = o.length; i--;) {
        P.push(o[i]);
      } else "boolean" == typeof o && (o = null), (r = "function" != typeof e) && (null == o ? o = "" : "number" == typeof o ? o += "" : "string" != typeof o && (r = !1)), r && n ? l[l.length - 1] += o : l === W ? l = [o] : l.push(o), n = r;
    }var a = new T();return a.nodeName = e, a.children = l, a.attributes = null == t ? void 0 : t, a.key = null == t ? void 0 : t.key, void 0 !== M.vnode && M.vnode(a), a;
  }function t(e, t) {
    for (var n in t) {
      e[n] = t[n];
    }return e;
  }function n(e, t) {
    null != e && ("function" == typeof e ? e(t) : e.current = t);
  }function o(n, o) {
    return e(n.nodeName, t(t({}, n.attributes), o), arguments.length > 2 ? [].slice.call(arguments, 2) : n.children);
  }function r(e) {
    !e.__d && (e.__d = !0) && 1 == V.push(e) && (M.debounceRendering || D)(i);
  }function i() {
    var e;while (e = V.pop()) {
      e.__d && x(e);
    }
  }function l(e, t, n) {
    return "string" == typeof t || "number" == typeof t ? void 0 !== e.splitText : "string" == typeof t.nodeName ? !e._componentConstructor && a(e, t.nodeName) : n || e._componentConstructor === t.nodeName;
  }function a(e, t) {
    return e.__n === t || e.nodeName.toLowerCase() === t.toLowerCase();
  }function u(e) {
    var n = t({}, e.attributes);n.children = e.children;var o = e.nodeName.defaultProps;if (void 0 !== o) for (var r in o) {
      void 0 === n[r] && (n[r] = o[r]);
    }return n;
  }function c(e, t) {
    var n = t ? document.createElementNS("http://www.w3.org/2000/svg", e) : document.createElement(e);return n.__n = e, n;
  }function p(e) {
    var t = e.parentNode;t && t.removeChild(e);
  }function s(e, t, o, r, i) {
    if ("className" === t && (t = "class"), "key" === t) ;else if ("ref" === t) n(o, null), n(r, e);else if ("class" !== t || i) {
      if ("style" === t) {
        if (r && "string" != typeof r && "string" != typeof o || (e.style.cssText = r || ""), r && "object" == typeof r) {
          if ("string" != typeof o) for (var l in o) {
            l in r || (e.style[l] = "");
          }for (var l in r) {
            e.style[l] = "number" == typeof r[l] && !1 === E.test(l) ? r[l] + "px" : r[l];
          }
        }
      } else if ("dangerouslySetInnerHTML" === t) r && (e.innerHTML = r.__html || "");else if ("o" == t[0] && "n" == t[1]) {
        var a = t !== (t = t.replace(/Capture$/, ""));t = t.toLowerCase().substring(2), r ? o || e.addEventListener(t, _, a) : e.removeEventListener(t, _, a), (e.__l || (e.__l = {}))[t] = r;
      } else if ("list" !== t && "type" !== t && !i && t in e) {
        try {
          e[t] = null == r ? "" : r;
        } catch (e) {}null != r && !1 !== r || "spellcheck" == t || e.removeAttribute(t);
      } else {
        var u = i && t !== (t = t.replace(/^xlink:?/, ""));null == r || !1 === r ? u ? e.removeAttributeNS("http://www.w3.org/1999/xlink", t.toLowerCase()) : e.removeAttribute(t) : "function" != typeof r && (u ? e.setAttributeNS("http://www.w3.org/1999/xlink", t.toLowerCase(), r) : e.setAttribute(t, r));
      }
    } else e.className = r || "";
  }function _(e) {
    return this.__l[e.type](M.event && M.event(e) || e);
  }function f() {
    var e;while (e = A.shift()) {
      M.afterMount && M.afterMount(e), e.componentDidMount && e.componentDidMount();
    }
  }function d(e, t, n, o, r, i) {
    H++ || (R = null != r && void 0 !== r.ownerSVGElement, B = null != e && !("__preactattr_" in e));var l = h(e, t, n, o, i);return r && l.parentNode !== r && r.appendChild(l), --H || (B = !1, i || f()), l;
  }function h(e, t, n, o, r) {
    var i = e,
        l = R;if (null != t && "boolean" != typeof t || (t = ""), "string" == typeof t || "number" == typeof t) return e && void 0 !== e.splitText && e.parentNode && (!e._component || r) ? e.nodeValue != t && (e.nodeValue = t) : (i = document.createTextNode(t), e && (e.parentNode && e.parentNode.replaceChild(i, e), v(e, !0))), i.__preactattr_ = !0, i;var u = t.nodeName;if ("function" == typeof u) return N(e, t, n, o);if (R = "svg" === u || "foreignObject" !== u && R, u += "", (!e || !a(e, u)) && (i = c(u, R), e)) {
      while (e.firstChild) {
        i.appendChild(e.firstChild);
      }e.parentNode && e.parentNode.replaceChild(i, e), v(e, !0);
    }var p = i.firstChild,
        s = i.__preactattr_,
        _ = t.children;if (null == s) {
      s = i.__preactattr_ = {};for (var f = i.attributes, d = f.length; d--;) {
        s[f[d].name] = f[d].value;
      }
    }return !B && _ && 1 === _.length && "string" == typeof _[0] && null != p && void 0 !== p.splitText && null == p.nextSibling ? p.nodeValue != _[0] && (p.nodeValue = _[0]) : (_ && _.length || null != p) && m(i, _, n, o, B || null != s.dangerouslySetInnerHTML), y(i, t.attributes, s), R = l, i;
  }function m(e, t, n, o, r) {
    var i,
        a,
        u,
        c,
        s,
        _ = e.childNodes,
        f = [],
        d = {},
        m = 0,
        b = 0,
        y = _.length,
        g = 0,
        w = t ? t.length : 0;if (0 !== y) for (var C = 0; C < y; C++) {
      var x = _[C],
          N = x.__preactattr_,
          k = w && N ? x._component ? x._component.__k : N.key : null;null != k ? (m++, d[k] = x) : (N || (void 0 !== x.splitText ? !r || x.nodeValue.trim() : r)) && (f[g++] = x);
    }if (0 !== w) for (var C = 0; C < w; C++) {
      c = t[C], s = null;var k = c.key;if (null != k) m && void 0 !== d[k] && (s = d[k], d[k] = void 0, m--);else if (b < g) for (i = b; i < g; i++) {
        if (void 0 !== f[i] && l(a = f[i], c, r)) {
          s = a, f[i] = void 0, i === g - 1 && g--, i === b && b++;break;
        }
      }s = h(s, c, n, o), u = _[C], s && s !== e && s !== u && (null == u ? e.appendChild(s) : s === u.nextSibling ? p(u) : e.insertBefore(s, u));
    }if (m) for (var C in d) {
      void 0 !== d[C] && v(d[C], !1);
    }while (b <= g) {
      void 0 !== (s = f[g--]) && v(s, !1);
    }
  }function v(e, t) {
    var o = e._component;o ? k(o) : (null != e.__preactattr_ && n(e.__preactattr_.ref, null), !1 !== t && null != e.__preactattr_ || p(e), b(e));
  }function b(e) {
    e = e.lastChild;while (e) {
      var t = e.previousSibling;v(e, !0), e = t;
    }
  }function y(e, t, n) {
    var o;for (o in n) {
      t && null != t[o] || null == n[o] || s(e, o, n[o], n[o] = void 0, R);
    }for (o in t) {
      "children" === o || "innerHTML" === o || o in n && t[o] === ("value" === o || "checked" === o ? e[o] : n[o]) || s(e, o, n[o], n[o] = t[o], R);
    }
  }function g(e, t, n) {
    var o,
        r = F.length;e.prototype && e.prototype.render ? (o = new e(t, n), U.call(o, t, n)) : (o = new U(t, n), o.constructor = e, o.render = w);while (r--) {
      if (F[r].constructor === e) return o.__b = F[r].__b, F.splice(r, 1), o;
    }return o;
  }function w(e, t, n) {
    return this.constructor(e, n);
  }function C(e, t, o, i, l) {
    e.__x || (e.__x = !0, e.__r = t.ref, e.__k = t.key, delete t.ref, delete t.key, void 0 === e.constructor.getDerivedStateFromProps && (!e.base || l ? e.componentWillMount && e.componentWillMount() : e.componentWillReceiveProps && e.componentWillReceiveProps(t, i)), i && i !== e.context && (e.__c || (e.__c = e.context), e.context = i), e.__p || (e.__p = e.props), e.props = t, e.__x = !1, 0 !== o && (1 !== o && !1 === M.syncComponentUpdates && e.base ? r(e) : x(e, 1, l)), n(e.__r, e));
  }function x(e, n, o, r) {
    if (!e.__x) {
      var i,
          l,
          a,
          c = e.props,
          p = e.state,
          s = e.context,
          _ = e.__p || c,
          h = e.__s || p,
          m = e.__c || s,
          b = e.base,
          y = e.__b,
          w = b || y,
          N = e._component,
          U = !1,
          S = m;if (e.constructor.getDerivedStateFromProps && (p = t(t({}, p), e.constructor.getDerivedStateFromProps(c, p)), e.state = p), b && (e.props = _, e.state = h, e.context = m, 2 !== n && e.shouldComponentUpdate && !1 === e.shouldComponentUpdate(c, p, s) ? U = !0 : e.componentWillUpdate && e.componentWillUpdate(c, p, s), e.props = c, e.state = p, e.context = s), e.__p = e.__s = e.__c = e.__b = null, e.__d = !1, !U) {
        i = e.render(c, p, s), e.getChildContext && (s = t(t({}, s), e.getChildContext())), b && e.getSnapshotBeforeUpdate && (S = e.getSnapshotBeforeUpdate(_, h));var L,
            T,
            P = i && i.nodeName;if ("function" == typeof P) {
          var W = u(i);l = N, l && l.constructor === P && W.key == l.__k ? C(l, W, 1, s, !1) : (L = l, e._component = l = g(P, W, s), l.__b = l.__b || y, l.__u = e, C(l, W, 0, s, !1), x(l, 1, o, !0)), T = l.base;
        } else a = w, L = N, L && (a = e._component = null), (w || 1 === n) && (a && (a._component = null), T = d(a, i, s, o || !b, w && w.parentNode, !0));if (w && T !== w && l !== N) {
          var D = w.parentNode;D && T !== D && (D.replaceChild(T, w), L || (w._component = null, v(w, !1)));
        }if (L && k(L), e.base = T, T && !r) {
          var E = e,
              V = e;while (V = V.__u) {
            (E = V).base = T;
          }T._component = E, T._componentConstructor = E.constructor;
        }
      }!b || o ? A.push(e) : U || (e.componentDidUpdate && e.componentDidUpdate(_, h, S), M.afterUpdate && M.afterUpdate(e));while (e.__h.length) {
        e.__h.pop().call(e);
      }H || r || f();
    }
  }function N(e, t, n, o) {
    var r = e && e._component,
        i = r,
        l = e,
        a = r && e._componentConstructor === t.nodeName,
        c = a,
        p = u(t);while (r && !c && (r = r.__u)) {
      c = r.constructor === t.nodeName;
    }return r && c && (!o || r._component) ? (C(r, p, 3, n, o), e = r.base) : (i && !a && (k(i), e = l = null), r = g(t.nodeName, p, n), e && !r.__b && (r.__b = e, l = null), C(r, p, 1, n, o), e = r.base, l && e !== l && (l._component = null, v(l, !1))), e;
  }function k(e) {
    M.beforeUnmount && M.beforeUnmount(e);var t = e.base;e.__x = !0, e.componentWillUnmount && e.componentWillUnmount(), e.base = null;var o = e._component;o ? k(o) : t && (null != t.__preactattr_ && n(t.__preactattr_.ref, null), e.__b = t, p(t), F.push(e), b(t)), n(e.__r, null);
  }function U(e, t) {
    this.__d = !0, this.context = t, this.props = e, this.state = this.state || {}, this.__h = [];
  }function S(e, t, n) {
    return d(n, e, {}, !1, t, !1);
  }function L() {
    return {};
  }var T = function T() {},
      M = {},
      P = [],
      W = [],
      D = "function" == typeof Promise ? Promise.resolve().then.bind(Promise.resolve()) : setTimeout,
      E = /acit|ex(?:s|g|n|p|$)|rph|ows|mnc|ntw|ine[ch]|zoo|^ord/i,
      V = [],
      A = [],
      H = 0,
      R = !1,
      B = !1,
      F = [];t(U.prototype, { setState: function setState(e, n) {
      this.__s || (this.__s = this.state), this.state = t(t({}, this.state), "function" == typeof e ? e(this.state, this.props) : e), n && this.__h.push(n), r(this);
    }, forceUpdate: function forceUpdate(e) {
      e && this.__h.push(e), x(this, 2);
    }, render: function render() {} });var j = { h: e, createElement: e, cloneElement: o, createRef: L, Component: U, render: S, rerender: i, options: M }; true ? module.exports = j : self.preact = j;
}();
//# sourceMappingURL=preact.min.js.map

/***/ }),

/***/ "FtD3":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var enhanceError = __webpack_require__("t8qj");

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */
module.exports = function createError(message, config, code, request, response) {
  var error = new Error(message);
  return enhanceError(error, config, code, request, response);
};

/***/ }),

/***/ "GHBc":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("cGG2");

module.exports = utils.isStandardBrowserEnv() ?

// Standard browser envs have full support of the APIs needed to test
// whether the request URL is of the same origin as current location.
function standardBrowserEnv() {
  var msie = /(msie|trident)/i.test(navigator.userAgent);
  var urlParsingNode = document.createElement('a');
  var originURL;

  /**
  * Parse a URL to discover it's components
  *
  * @param {String} url The URL to be parsed
  * @returns {Object}
  */
  function resolveURL(url) {
    var href = url;

    if (msie) {
      // IE needs attribute set twice to normalize properties
      urlParsingNode.setAttribute('href', href);
      href = urlParsingNode.href;
    }

    urlParsingNode.setAttribute('href', href);

    // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
    return {
      href: urlParsingNode.href,
      protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
      host: urlParsingNode.host,
      search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
      hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
      hostname: urlParsingNode.hostname,
      port: urlParsingNode.port,
      pathname: urlParsingNode.pathname.charAt(0) === '/' ? urlParsingNode.pathname : '/' + urlParsingNode.pathname
    };
  }

  originURL = resolveURL(window.location.href);

  /**
  * Determine if a URL shares the same origin as the current location
  *
  * @param {String} requestURL The URL to test
  * @returns {boolean} True if URL shares the same origin, otherwise false
  */
  return function isURLSameOrigin(requestURL) {
    var parsed = utils.isString(requestURL) ? resolveURL(requestURL) : requestURL;
    return parsed.protocol === originURL.protocol && parsed.host === originURL.host;
  };
}() :

// Non standard browser envs (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
  return function isURLSameOrigin() {
    return true;
  };
}();

/***/ }),

/***/ "JP+z":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};

/***/ }),

/***/ "JkW7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/preact/dist/preact.min.js
var preact_min = __webpack_require__("EBst");
var preact_min_default = /*#__PURE__*/__webpack_require__.n(preact_min);

// EXTERNAL MODULE: ./index.module.scss
var index_module = __webpack_require__("NffV");
var index_module_default = /*#__PURE__*/__webpack_require__.n(index_module);

// EXTERNAL MODULE: ./node_modules/@fortawesome/fontawesome-free/css/all.min.css
var all_min = __webpack_require__("jKqc");
var all_min_default = /*#__PURE__*/__webpack_require__.n(all_min);

// CONCATENATED MODULE: ./components/header/profile.js


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



var _ref = Object(preact_min["h"])(
  "span",
  null,
  "Logout"
);

var _ref2 = Object(preact_min["h"])(
  "div",
  { className: "profile-img" },
  Object(preact_min["h"])("i", { className: "fas fa-user" })
);

var _ref3 = Object(preact_min["h"])("i", { className: "fas fa-cog" });

var profile_Profile = function (_Component) {
  _inherits(Profile, _Component);

  function Profile() {
    _classCallCheck(this, Profile);

    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  Profile.prototype.render = function render(props, state) {
    var account = props.account;
    return Object(preact_min["h"])(
      "div",
      null,
      account && Object(preact_min["h"])(
        "div",
        { id: "profile-container" },
        Object(preact_min["h"])(
          "div",
          { id: "profile-menu", className: props.profileMenuOpen ? "" : "hidden", onClick: function onClick() {
              return props.logoutCallbackWrapper();
            } },
          _ref
        ),
        _ref2,
        Object(preact_min["h"])(
          "div",
          { id: "profile" },
          Object(preact_min["h"])(
            "div",
            { id: "profile-name" },
            Object(preact_min["h"])(
              "span",
              { className: "overflow-ellipsis" },
              account.Name
            )
          ),
          Object(preact_min["h"])(
            "div",
            { id: "profile-title" },
            account.Role && account.Role.Name
          )
        ),
        Object(preact_min["h"])(
          "button",
          { className: "settings-button", onClick: function onClick() {
              return props.toggleProfileMenu();
            } },
          _ref3
        )
      )
    );
  };

  return Profile;
}(preact_min["Component"]);


// CONCATENATED MODULE: ./components/header/header.js


function header__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function header__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function header__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var header__ref = Object(preact_min["h"])('i', { className: "fas fa-bars" });

var header_Header = function (_Component) {
  header__inherits(Header, _Component);

  function Header() {
    header__classCallCheck(this, Header);

    return header__possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  Header.prototype.render = function render(props, state) {
    var account = props.account;

    return Object(preact_min["h"])(
      'header',
      { id: 'header-container', className: props.sideMenuOpen ? "side-menu-open" : "side-menu-closed" },
      Object(preact_min["h"])(
        'button',
        { onClick: props.toggleMenu, className: 'veyobar-collapse-button' },
        header__ref
      ),
      Object(preact_min["h"])(profile_Profile, { account: account, profileMenuOpen: props.profileMenuOpen, toggleProfileMenu: props.toggleProfileMenu, logoutCallbackWrapper: props.logoutCallbackWrapper })
    );
  };

  return Header;
}(preact_min["Component"]);


// CONCATENATED MODULE: ./components/sidebar/logo.js


function logo__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function logo__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function logo__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



var axios = __webpack_require__("mtWM").default;

var logo_Logo = function (_Component) {
	logo__inherits(Logo, _Component);

	function Logo() {
		var _temp, _this, _ret;

		logo__classCallCheck(this, Logo);

		for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
			args[_key] = arguments[_key];
		}

		return _ret = (_temp = (_this = logo__possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.veyoLogoUrl = 'https://jadzia.azureedge.net/veyobar/assets/mtm-logo.png', _temp), logo__possibleConstructorReturn(_this, _ret);
	}

	Logo.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
		var _this2 = this;

		if (prevProps.logoUrl !== this.props.logoUrl) {
			axios.get(this.props.logoUrl, { headers: { 'X-AuthToken': this.props.authToken }, responseType: 'arraybuffer' }).then(function (res) {

				if (res.status === 200) {
					var data = new Uint8Array(res.data);
					var raw = String.fromCharCode.apply(null, data);
					var base64 = btoa(raw);
					var src = "data:image;base64," + base64;

					_this2.img.src = src;
				}
			}, function (rejected) {
				_this2.img.src = _this2.veyoLogoUrl;
			}).catch(function (err) {
				_this2.img.src = _this2.veyoLogoUrl;
			});
		}
	};

	Logo.prototype.render = function render(props, state) {
		var _this3 = this;

		return Object(preact_min["h"])(
			'div',
			{ id: 'logo-section' },
			Object(preact_min["h"])('img', { src: this.veyoLogoUrl, alt: "Loading...", ref: function ref(e) {
					return _this3.img = e;
				} })
		);
	};

	return Logo;
}(preact_min["Component"]);


// CONCATENATED MODULE: ./components/sidebar/navigationArrow.js


function navigationArrow__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function navigationArrow__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function navigationArrow__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



var navigationArrow__ref = Object(preact_min["h"])("i", { className: "fas fa-chevron-left" });

var navigationArrow__ref2 = Object(preact_min["h"])("i", { className: "fas fa-chevron-down" });

var navigationArrow_NavigationArrow = function (_Component) {
  navigationArrow__inherits(NavigationArrow, _Component);

  function NavigationArrow() {
    navigationArrow__classCallCheck(this, NavigationArrow);

    return navigationArrow__possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  NavigationArrow.prototype.render = function render(props, state) {

    return Object(preact_min["h"])(
      "span",
      null,
      props.show && !props.open && navigationArrow__ref,
      props.show && props.open && navigationArrow__ref2
    );
  };

  return NavigationArrow;
}(preact_min["Component"]);


// CONCATENATED MODULE: ./components/sidebar/navigationBase.js


function navigationBase__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function navigationBase__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function navigationBase__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var navigationBase_NavigationBase = function (_Component) {
  navigationBase__inherits(NavigationBase, _Component);

  function NavigationBase() {
    navigationBase__classCallCheck(this, NavigationBase);

    return navigationBase__possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  NavigationBase.prototype.render = function render(props, state) {

    var linkAction = function linkAction(e) {
      props.removeMenuItem(props.item);
      e.stopPropagation();
    };

    return Object(preact_min["h"])(
      'div',
      { className: "navigation-link-base-container" },
      Object(preact_min["h"])(
        'div',
        { className: "navigation-link-base-icon-title" },
        Object(preact_min["h"])('i', { className: "fas " + props.item.Icon }),
        Object(preact_min["h"])(
          'span',
          null,
          props.item.Name
        )
      ),
      Object(preact_min["h"])(navigationArrow_NavigationArrow, { show: props.dropdown, open: props.open }),
      !props.dropdown && !!props.item.Removable && Object(preact_min["h"])(
        'div',
        { className: "navigation-link-base-close" },
        Object(preact_min["h"])('i', { onClick: linkAction, className: "fas fa-times" })
      )
    );
  };

  return NavigationBase;
}(preact_min["Component"]);


// CONCATENATED MODULE: ./components/sidebar/navigationFinalLink.js


function navigationFinalLink__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function navigationFinalLink__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function navigationFinalLink__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var navigationFinalLink_NavigationFinalLinks = function (_Component) {
  navigationFinalLink__inherits(NavigationFinalLinks, _Component);

  function NavigationFinalLinks() {
    var _temp, _this, _ret;

    navigationFinalLink__classCallCheck(this, NavigationFinalLinks);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = navigationFinalLink__possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.userHasPermission = function (finalItem, account) {
      var finalItemPermissions = finalItem.Permissions;

      if (!account || !account.Permissions) {
        return false;
      }

      if (!finalItemPermissions || finalItemPermissions.length <= 0) {
        return true;
      }

      var currentUserPermissions = account.Permissions;

      // the user must have at least one of the permissions to have access
      var isPermitted = finalItemPermissions.some(function (permissionRequired) {

        // return currentUserPermissions.indexOf(permissionRequired) !== -1
        return currentUserPermissions.map(function (permission) {
          return !permissionRequired || permission.Action === permissionRequired.Action && permission.Name === permissionRequired.Name && permission.Prefix === permissionRequired.Prefix && permission.UserType === permissionRequired.UserType;
        }).filter(function (m) {
          return m;
        }).length > 0;
      });

      return isPermitted;
    }, _temp), navigationFinalLink__possibleConstructorReturn(_this, _ret);
  }

  // the user has permission to view the item, or any sub item or final item on it


  NavigationFinalLinks.prototype.render = function render(props, state) {
    var _this2 = this;

    var account = props.account;
    var userHasPermission = function userHasPermission(finalItem, account) {
      return _this2.userHasPermission(finalItem, account);
    };

    return Object(preact_min["h"])(
      'div',
      null,
      ' ',
      props.subItem.FinalItems.map(function (finalItem, index) {
        var hasPermission = userHasPermission(finalItem, account);

        finalItem.quickAccess = [props.item.quickAccess[0], props.subItem.quickAccess[1], index];
        // the final item in the list is active
        var active = props.activatedPath.item === props.item.Name && props.activatedPath.subItem === props.subItem.Name && props.activatedPath.finalItem === finalItem.Name;

        var linkClass = "navigation-final-link" + (active ? " active" : " ");
        var linkAction = function linkAction(e) {
          props.setPathActive(props.item.Name, props.subItem.Name, finalItem.Name);
          props.navigationCallback(finalItem.Path);
        };

        return Object(preact_min["h"])(
          'div',
          null,
          hasPermission && !finalItem.External && Object(preact_min["h"])(
            'div',
            { className: linkClass, onClick: linkAction },
            Object(preact_min["h"])(navigationBase_NavigationBase, { removeMenuItem: props.removeMenuItem, dropdown: false, open: false, item: finalItem })
          ),
          hasPermission && finalItem.External && Object(preact_min["h"])(
            'a',
            { href: finalItem.Path, className: "navigation-final-link external-link" },
            Object(preact_min["h"])(navigationBase_NavigationBase, { removeMenuItem: props.removeMenuItem, dropdown: false, open: false, item: finalItem })
          )
        );
      })
    );
  };

  return NavigationFinalLinks;
}(preact_min["Component"]);


// CONCATENATED MODULE: ./components/sidebar/navigationSubLink.js


function navigationSubLink__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function navigationSubLink__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function navigationSubLink__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var navigationSubLink_NavigationSubLinks = function (_Component) {
  navigationSubLink__inherits(NavigationSubLinks, _Component);

  function NavigationSubLinks() {
    var _temp, _this, _ret;

    navigationSubLink__classCallCheck(this, NavigationSubLinks);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = navigationSubLink__possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.getSubItemPermissions = function (subItem) {
      var _subItemPermissions;

      var subItemPermissions = subItem.Permissions ? subItem.Permissions : [];
      subItemPermissions = (_subItemPermissions = subItemPermissions).concat.apply(_subItemPermissions, _this.getFinalItemPermissions(subItem));
      return subItemPermissions;
    }, _this.getFinalItemPermissions = function (subItem) {
      return subItem.FinalItems ? subItem.FinalItems.map(function (f) {
        return f.Permissions ? f.Permissions : [];
      }) : [];
    }, _this.userHasPermission = function (subItem, account) {
      var subItemPermissions = _this.getSubItemPermissions(subItem);

      if (!account || !account.Permissions) {
        return false;
      }

      if (!subItemPermissions || subItemPermissions.length <= 0) {
        return true;
      }

      var currentUserPermissions = account.Permissions;

      // the user must have at least one of the permissions to have access
      var isPermitted = subItemPermissions.some(function (permissionRequired) {

        // return currentUserPermissions.indexOf(permissionRequired) !== -1
        return currentUserPermissions.map(function (permission) {
          return !permissionRequired || permission.Action === permissionRequired.Action && permission.Name === permissionRequired.Name && permission.Prefix === permissionRequired.Prefix && permission.UserType === permissionRequired.UserType;
        }).filter(function (m) {
          return m;
        }).length > 0;
      });

      return isPermitted;
    }, _temp), navigationSubLink__possibleConstructorReturn(_this, _ret);
  }

  // the user has permission to view the item, or any sub item or final item on it


  NavigationSubLinks.prototype.render = function render(props, state) {
    var _this2 = this;

    var account = props.account;
    var userHasPermission = function userHasPermission(subItem, account) {
      return _this2.userHasPermission(subItem, account);
    };

    if (!props.item.SubItems) {
      return null;
    }

    return Object(preact_min["h"])(
      'div',
      null,
      props.item.SubItems.map(function (subItem, index) {
        var hasPermission = userHasPermission(subItem, account);

        subItem.quickAccess = [props.item.quickAccess[0], index];
        var linkAction = function linkAction(e) {
          if (!!subItem.FinalItems && subItem.FinalItems.length > 0) {
            props.toggleMenuSubItem(subItem.Name);
          } else {
            props.setPathActive(props.item.Name, subItem.Name);
            props.navigationCallback(subItem.Path);
          }
        };

        var open = props.openedMenuItems.subItems.indexOf(subItem.Name) >= 0;
        var active = props.activatedPath.item === props.item.Name && props.activatedPath.subItem === subItem.Name;

        return Object(preact_min["h"])(
          'div',
          null,
          hasPermission && !subItem.External && Object(preact_min["h"])(
            'div',
            null,
            Object(preact_min["h"])(
              'div',
              { onClick: linkAction, className: "navigation-sub-link" + (active ? " active" : " ") },
              Object(preact_min["h"])(navigationBase_NavigationBase, { removeMenuItem: props.removeMenuItem, dropdown: !!subItem.FinalItems && subItem.FinalItems.length > 0, open: open, item: subItem })
            ),
            open && !!subItem.FinalItems && Object(preact_min["h"])(
              'div',
              null,
              Object(preact_min["h"])(navigationFinalLink_NavigationFinalLinks, {
                activatedPath: props.activatedPath,
                item: props.item,
                removeMenuItem: props.removeMenuItem,
                subItem: subItem,
                finalItems: subItem.FinalItems,
                navigationCallback: props.navigationCallback,
                setPathActive: props.setPathActive,
                account: props.account })
            )
          ),
          hasPermission && subItem.External && Object(preact_min["h"])(
            'a',
            { href: subItem.Path, className: "navigation-sub-link external-link" },
            Object(preact_min["h"])(navigationBase_NavigationBase, { removeMenuItem: props.removeMenuItem, dropdown: false, open: false, item: subItem })
          )
        );
      })
    );
  };

  return NavigationSubLinks;
}(preact_min["Component"]);


// CONCATENATED MODULE: ./components/sidebar/navigationlink.js


function navigationlink__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function navigationlink__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function navigationlink__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var navigationlink_NavigationLink = function (_Component) {
  navigationlink__inherits(NavigationLink, _Component);

  function NavigationLink() {
    navigationlink__classCallCheck(this, NavigationLink);

    return navigationlink__possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  NavigationLink.prototype.render = function render(props, state) {

    var open = props.openedMenuItems.items.indexOf(props.item.Name) >= 0;
    var active = props.activatedPath.item === props.item.Name;

    var linkAction = function linkAction(e) {
      if (!!props.item.SubItems && props.item.SubItems.length > 0) {
        props.toggleMenuItem(props.item.Name);
      } else {
        props.setPathActive(props.item.Name);
        props.navigationCallback(props.item.Path);
      }
    };

    return Object(preact_min["h"])(
      'div',
      null,
      !props.item.External && Object(preact_min["h"])(
        'div',
        null,
        Object(preact_min["h"])(
          'div',
          { onClick: linkAction, className: "navigation-link " + (active ? "active " : " ") + (open ? "open" : "closed") },
          Object(preact_min["h"])(navigationBase_NavigationBase, { removeMenuItem: props.removeMenuItem, dropdown: !!props.item.SubItems && props.item.SubItems.length > 0, open: open, item: props.item })
        ),
        open && !!props.item.SubItems && Object(preact_min["h"])(navigationSubLink_NavigationSubLinks, {
          activatedPath: props.activatedPath,
          openedMenuItems: props.openedMenuItems,
          removeMenuItem: props.removeMenuItem,
          item: props.item,
          navigationCallback: props.navigationCallback,
          setPathActive: props.setPathActive,
          toggleMenuSubItem: props.toggleMenuSubItem,
          account: props.account })
      ),
      props.item.External && Object(preact_min["h"])(
        'a',
        { href: props.item.Path, className: "navigation-link External-link" },
        Object(preact_min["h"])(navigationBase_NavigationBase, { removeMenuItem: props.removeMenuItem, dropdown: false, open: false, item: props.item })
      )
    );
  };

  return NavigationLink;
}(preact_min["Component"]);


// CONCATENATED MODULE: ./components/sidebar/versionmenu.js


function versionmenu__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function versionmenu__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function versionmenu__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



var versionmenu__ref = Object(preact_min["h"])('i', { className: "fas fa-ellipsis-h" });

var versionmenu__ref2 = Object(preact_min["h"])(
  'span',
  { className: 'header' },
  'System Information'
);

var versionmenu__ref3 = Object(preact_min["h"])(
  'span',
  { className: 'footer' },
  'Covered by U.S. Patent No. 9,020,842'
);

var versionmenu_VersionMenu = function (_Component) {
  versionmenu__inherits(VersionMenu, _Component);

  function VersionMenu() {
    versionmenu__classCallCheck(this, VersionMenu);

    return versionmenu__possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  VersionMenu.prototype.render = function render(props, state) {
    var apps = props.appVersions.map(function (a) {
      return Object(preact_min["h"])(
        'li',
        null,
        Object(preact_min["h"])(
          'strong',
          null,
          a.name
        ),
        Object(preact_min["h"])(
          'span',
          { className: "overflow-ellipsis" },
          a.version,
          !!a.environment ? ' - ' + a.environment : ''
        )
      );
    });
    return Object(preact_min["h"])(
      'div',
      { id: 'version-menu-container' },
      Object(preact_min["h"])(
        'button',
        { onClick: function onClick() {
            return props.toggleVersionMenu();
          } },
        versionmenu__ref
      ),
      Object(preact_min["h"])(
        'div',
        { onClick: function onClick() {
            return props.toggleVersionMenu();
          }, id: 'version-menu', className: props.versionMenuOpen ? "" : "hidden" },
        versionmenu__ref2,
        Object(preact_min["h"])(
          'ul',
          null,
          apps
        ),
        versionmenu__ref3
      )
    );
  };

  return VersionMenu;
}(preact_min["Component"]);


// CONCATENATED MODULE: ./components/sidebar/sidebar.js


function sidebar__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function sidebar__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function sidebar__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var sidebar_Sidebar = function (_Component) {
  sidebar__inherits(Sidebar, _Component);

  function Sidebar() {
    var _temp, _this, _ret;

    sidebar__classCallCheck(this, Sidebar);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = sidebar__possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.getItemPermissions = function (item) {
      var _itemPermissions;

      var itemPermissions = item.Permissions ? item.Permissions : [];
      itemPermissions = (_itemPermissions = itemPermissions).concat.apply(_itemPermissions, _this.getSubItemPermissions(item));
      return itemPermissions;
    }, _this.getSubItemPermissions = function (item) {
      return item.SubItems ? item.SubItems.map(function (s) {
        var subItemPermissions = s.Permissions ? s.Permissions : [];
        return subItemPermissions.concat.apply(subItemPermissions, _this.getFinalItemPermissions(s));
      }) : [];
    }, _this.getFinalItemPermissions = function (subItem) {
      return subItem.FinalItems ? subItem.FinalItems.map(function (f) {
        return f.Permissions;
      }) : [];
    }, _this.userHasPermission = function (item, account) {
      var itemPermissions = _this.getItemPermissions(item);

      if (!account || !account.Permissions) {
        return false;
      }

      if (!itemPermissions || itemPermissions.length <= 0) {
        return true;
      }

      var currentUserPermissions = account.Permissions;

      // the user must have at least one of the permissions to have access
      var isPermitted = itemPermissions.some(function (permissionRequired) {

        // return currentUserPermissions.indexOf(permissionRequired) !== -1
        return currentUserPermissions.map(function (permission) {
          return !permissionRequired || permission.Action === permissionRequired.Action && permission.Name === permissionRequired.Name && permission.Prefix === permissionRequired.Prefix && permission.UserType === permissionRequired.UserType;
        }).filter(function (m) {
          return m;
        }).length > 0;
      });

      return isPermitted;
    }, _temp), sidebar__possibleConstructorReturn(_this, _ret);
  }

  // the user has permission to view the item, or any sub item or final item on it


  Sidebar.prototype.render = function render(props, state) {
    var _this2 = this;

    var account = props.account;
    var userHasPermission = function userHasPermission(item, account) {
      return _this2.userHasPermission(item, account);
    };

    var listItems = props.menu.map(function (item, index) {
      var hasPermission = userHasPermission(item, account);
      item.quickAccess = [index];
      return hasPermission && Object(preact_min["h"])(navigationlink_NavigationLink, {
        toggleMenuItem: props.toggleMenuItem,
        toggleMenuSubItem: props.toggleMenuSubItem,
        active: props.selected == item.Name,
        item: item,
        navigationCallback: props.navigationCallback,
        openedMenuItems: props.openedMenuItems,
        removeMenuItem: props.removeMenuItem,
        setPathActive: props.setPathActive,
        activatedPath: props.activatedPath,
        account: props.account });
    });
    return Object(preact_min["h"])(
      'div',
      { id: 'sidebar-container' },
      Object(preact_min["h"])(logo_Logo, { logoUrl: props.logoUrl, authToken: props.authToken }),
      Object(preact_min["h"])(
        'div',
        { id: 'menu-items' },
        account && Object(preact_min["h"])(
          'span',
          null,
          listItems
        )
      ),
      Object(preact_min["h"])(versionmenu_VersionMenu, {
        versionMenuOpen: props.versionMenuOpen,
        toggleVersionMenu: props.toggleVersionMenu,
        veyobarVersion: props.veyobarVersion,
        appVersions: props.appVersions })
    );
  };

  return Sidebar;
}(preact_min["Component"]);


// CONCATENATED MODULE: ./test/default-menu.js
var menuIcons = {
  menuIconArchive: 'fa-archive',
  menuIconArrowLeft: 'fa-arrow-left',
  menuIconBarChart: 'fa-file',
  menuIconBus: 'fa-bus',
  menuIconClipboardList: 'fa-clipboard-list',
  menuIconCog: 'fa-cog',
  menuIconCurrency: 'fa-dollar-sign',
  menuIconFlag: 'fa-flag',
  menuIconFolder: 'fa-folder',
  menuIconFolderOpen: 'fa-folder-open',
  menuIconGasPump: 'fa-gas-pump',
  menuIconMail: 'fa-envelope',
  menuIconMap: 'fa-map',
  menuIconMapMarkerAlt: 'fa-map-marker-alt',
  menuIconRss: 'fa-rss',
  menuIconSignal: 'fa-signal',
  menuIconTicket: 'fa-ticket-alt',
  menuIconTrophy: 'fa-trophy',
  menuIconUser: 'fa-user',
  menuIconUsers: 'fa-users',
  menuIconUserFriends: 'fa-user-friends',
  menuIconUpload: 'fa-upload',
  menuIconVehicles: 'fa-car',
  menuIconWrench: 'fa-wrench'
};

var projectKeys = {
  AD_OPERATOR: 'AD_OPERATOR',
  AD_ADMINISTRATOR: 'AD_ADMINISTRATOR',
  LD: 'LD',
  LEV: 'LEV',
  PTF: 'PTF',
  PPU: 'PPU',
  MRBPOR: 'MRBPOR'
};

var areaKeys = {
  AD: 'ADMINISTRATOR',
  LD: 'ADMINISTRATOR',
  LEV: 'ADMINISTRATOR',
  PTF: 'ADMINISTRATOR',
  PPU: 'OPERATOR',
  MRBPOR: 'ADMINISTRATOR'
};

var externalPaths = {
  AD_ADMINISTRATOR: {
    DEMO: 'http://demo.portal.veyo.com/',
    DEV: 'http://test.portal.veyo.com/',
    TEST: 'http://test.portal.veyo.com/',
    INTEGRATION: 'http://integration.portal.veyo.com/',
    STAGING: 'http://integration.portal.veyo.com/',
    PROD: 'https://portal.veyo.com/',
    PRODUCTION: 'https://portal.veyo.com/',
    LIVE: 'https://portal.veyo.com/'
  },
  AD_OPERATOR: {
    DEMO: 'http://demo.providers.veyo.com/',
    DEV: 'http://test.providers.veyo.com/',
    TEST: 'http://test.providers.veyo.com/',
    INTEGRATION: 'http://integration.providers.veyo.com/',
    STAGING: 'http://integration.providers.veyo.com/',
    PROD: 'https://providers.veyo.com/',
    PRODUCTION: 'https://providers.veyo.com/',
    LIVE: 'https://providers.veyo.com/'
  },
  LEV: {
    DEMO: 'https://demo.veyo.io/portal/',
    DEV: 'https://test.veyo.io/portal/',
    TEST: 'https://test.veyo.io/portal/',
    INTEGRATION: 'https://integration.veyo.io/portal/',
    STAGING: 'https://staging.veyo.io/portal/',
    PROD: 'https://live.veyo.io/portal/',
    PRODUCTION: 'https://live.veyo.io/portal/',
    LIVE: 'https://live.veyo.io/portal/'
  },
  PTF: {
    DEMO: 'https://demo.veyo.io/transit/',
    DEV: 'https://test.veyo.io/transit/',
    TEST: 'https://test.veyo.io/transit/',
    INTEGRATION: 'https://integration.veyo.io/transit/',
    STAGING: 'https://staging.veyo.io/transit/',
    PROD: 'https://live.veyo.io/transit/',
    PRODUCTION: 'https://live.veyo.io/transit/',
    LIVE: 'https://live.veyo.io/transit/'
  },
  PPU: {
    DEMO: 'https://demo.veyo.io/provider/',
    DEV: 'https://test.veyo.io/provider/',
    TEST: 'https://test.veyo.io/provider/',
    INTEGRATION: 'https://integration.veyo.io/provider/',
    STAGING: 'https://staging.veyo.io/provider/',
    PROD: 'https://live.veyo.io/provider/',
    PRODUCTION: 'https://live.veyo.io/provider/',
    LIVE: 'https://live.veyo.io/provider/'
  },
  LD: {
    DEMO: 'https://demo.veyo.io/routing/',
    DEV: 'https://test.veyo.io/routing/',
    TEST: 'https://test.veyo.io/routing/',
    INTEGRATION: 'https://integration.veyo.io/routing/',
    STAGING: 'https://staging.veyo.io/routing/',
    PROD: 'https://live.veyo.io/routing/',
    PRODUCTION: 'https://live.veyo.io/routing/',
    LIVE: 'https://live.veyo.io/routing/'
  },
  MRBPOR: {
    DEMO: 'https://demo.veyo.io/mrb/',
    DEV: 'https://test.veyo.io/mrb/',
    TEST: 'https://test.veyo.io/mrb/',
    INTEGRATION: 'https://integration.veyo.io/mrb/',
    STAGING: 'https://staging.veyo.io/mrb/',
    PROD: 'https://live.veyo.io/mrb/',
    PRODUCTION: 'https://live.veyo.io/mrb/',
    LIVE: 'https://live.veyo.io/mrb/'
  }
};

var linkIsInternal = function linkIsInternal(menuItemKey, projectKey) {
  return menuItemKey.toUpperCase() === projectKey.toUpperCase();;
};

var linkIsExternal = function linkIsExternal(menuItemKey, projectKey) {
  return !linkIsInternal(menuItemKey, projectKey);
};

var getPath = function getPath(menuItemKey, projectKey, environmentKey, route) {

  // internal link
  if (linkIsInternal(menuItemKey, projectKey)) {
    return route;
  }

  if (!externalPaths[menuItemKey] || !externalPaths[menuItemKey][environmentKey]) {
    return 'invalid project or environment for menu';
  }

  // external link
  return externalPaths[menuItemKey][environmentKey] + route;
};

var getAdminMenu = function getAdminMenu(projectKey, environmentKey) {
  return [{
    Name: 'Rescue Dispatch',
    Icon: menuIcons.menuIconRss,
    External: linkIsExternal(projectKeys.LEV, projectKey),
    Path: getPath(projectKeys.LEV, projectKey, environmentKey, 'dispatch/ondemand'),
    Removable: false,
    Permissions: [{
      Action: 'Query',
      Name: 'DispatchTrips',
      Prefix: 'Portal',
      UserType: 'Administrator'
    }],
    Order: 0
  }, {
    Name: 'Peak Time Rewards',
    Icon: menuIcons.menuIconTrophy,
    External: false,
    Removable: false,
    Order: 1,
    SubItems: [{
      Name: 'Manage Campaigns',
      Icon: menuIcons.menuIconTrophy,
      External: linkIsExternal(projectKeys.LEV, projectKey),
      Path: getPath(projectKeys.LEV, projectKey, environmentKey, 'campaigns/manage'),
      Removable: false,
      Order: 0,
      Permissions: [{
        Action: 'Query',
        Name: 'PeakTimeRewardCampaign',
        Prefix: 'Portal',
        UserType: 'Administrator'
      }]
    }, {
      Name: 'Create Campaign',
      Icon: menuIcons.menuIconTrophy,
      External: linkIsExternal(projectKeys.LEV, projectKey),
      Path: getPath(projectKeys.LEV, projectKey, environmentKey, 'campaigns/create'),
      Removable: false,
      Order: 1,
      Permissions: [{
        Action: 'Create',
        Name: 'PeakTimeRewardCampaign',
        Prefix: 'Portal',
        UserType: 'Administrator'
      }, {
        Action: 'Update',
        Name: 'PeakTimeRewardCampaign',
        Prefix: 'Portal',
        UserType: 'Administrator'
      }]
    }]
  }, {
    Name: 'Trips',
    Icon: menuIcons.menuIconMapMarkerAlt,
    External: false,
    Removable: false,
    Order: 2,
    SubItems: []
  }, {
    Name: 'Platform',
    Icon: menuIcons.menuIconArrowLeft,
    External: true,
    Path: getPath(projectKeys.AD_ADMINISTRATOR, projectKey, environmentKey, ''),
    Removable: false,
    Order: 4
  }];
};

var getOperatorMenu = function getOperatorMenu(projectKey, environmentKey) {
  return [{
    Name: 'Trip Management',
    Icon: menuIcons.menuIconRss,
    External: false,
    Removable: false,
    Order: 0,
    SubItems: [{
      Name: 'Accept Trips',
      Icon: menuIcons.menuIconMapMarkerAlt,
      External: linkIsExternal(projectKeys.AD_OPERATOR, projectKey),
      Path: getPath(projectKeys.AD_OPERATOR, projectKey, environmentKey, ''),
      Removable: false,
      Order: 0,
      Permissions: [{
        Action: 'Query',
        Name: 'DispatchTrips',
        Prefix: 'Portal',
        UserType: 'Operator'
      }]
    }, {
      Name: 'View Accepted Trips',
      Icon: menuIcons.menuIconMapMarkerAlt,
      External: linkIsExternal(projectKeys.AD_OPERATOR, projectKey),
      Path: getPath(projectKeys.AD_OPERATOR, projectKey, environmentKey, 'confirmed'),
      Removable: false,
      Order: 1,
      Permissions: [{
        Action: 'Query',
        Name: 'DispatchTrips',
        Prefix: 'Portal',
        UserType: 'Operator'
      }]
    }, {
      Name: 'Review Revised Trips',
      Icon: menuIcons.menuIconMapMarkerAlt,
      External: linkIsExternal(projectKeys.AD_OPERATOR, projectKey),
      Path: getPath(projectKeys.AD_OPERATOR, projectKey, environmentKey, 'revisedTrips'),
      Removable: false,
      Order: 2,
      Permissions: [{
        Action: 'Query',
        Name: 'TripRevision',
        Prefix: 'Portal',
        UserType: 'Operator'
      }]
    }, {
      Name: 'View Cancelled Trips',
      Icon: menuIcons.menuIconMapMarkerAlt,
      External: linkIsExternal(projectKeys.AD_OPERATOR, projectKey),
      Path: getPath(projectKeys.AD_OPERATOR, projectKey, environmentKey, 'cancelled'),
      Removable: false,
      Order: 3,
      Permissions: [{
        Action: 'Query',
        Name: 'DispatchTrips',
        Prefix: 'Portal',
        UserType: 'Operator'
      }]
    }, {
      Name: 'Assign Trips to Drivers',
      Icon: menuIcons.menuIconUpload,
      External: linkIsExternal(projectKeys.AD_OPERATOR, projectKey),
      Path: getPath(projectKeys.AD_OPERATOR, projectKey, environmentKey, 'driverassignment'),
      Removable: false,
      Order: 5,
      Permissions: [{
        Action: 'Import',
        Name: 'DispatchTrips',
        Prefix: 'Portal',
        UserType: 'Operator'
      }]
    }, {
      Name: 'Finalize Trips',
      Icon: menuIcons.menuIconMapMarkerAlt,
      External: linkIsExternal(projectKeys.PPU, projectKey),
      Path: getPath(projectKeys.PPU, projectKey, environmentKey, 'finalization'),
      Removable: false,
      Order: 6,
      Permissions: [{
        Action: 'Query',
        Name: 'Dispatch.FinalizationTrips',
        Prefix: 'Portal',
        UserType: 'Operator'
      }]
    }, {
      Name: 'Payment History',
      Icon: menuIcons.menuIconCurrency,
      External: linkIsExternal(projectKeys.AD_OPERATOR, projectKey),
      Path: getPath(projectKeys.AD_OPERATOR, projectKey, environmentKey, 'paymentHistory'),
      Removable: false,
      Order: 7,
      Permissions: [{
        Action: 'Query',
        Name: 'Dispatch.PaymentHistory',
        Prefix: 'Portal',
        UserType: 'Operator'
      }]
    }, {
      Name: 'Mercy Care Billing',
      Icon: menuIcons.menuIconMapMarkerAlt,
      External: linkIsExternal(projectKeys.AD_OPERATOR, projectKey),
      Path: getPath(projectKeys.AD_OPERATOR, projectKey, environmentKey, 'mercyCareBilling'),
      Removable: false,
      Order: 8,
      Permissions: [{
        Action: 'Query',
        Name: 'ViewMercyCareTrips',
        Prefix: 'Portal',
        UserType: 'Operator'
      }]
    }]
  }, {
    Name: 'Drivers',
    Icon: menuIcons.menuIconUser,
    External: linkIsExternal(projectKeys.AD_OPERATOR, projectKey),
    Path: getPath(projectKeys.AD_OPERATOR, projectKey, environmentKey, 'drivers'),
    Order: 2,
    Permissions: [{
      Action: 'Query',
      Name: 'Driver',
      Prefix: 'Portal',
      UserType: 'Operator'
    }]
  }, {
    Name: 'Vehicles',
    Icon: menuIcons.menuIconVehicles,
    External: linkIsExternal(projectKeys.AD_OPERATOR, projectKey),
    Path: getPath(projectKeys.AD_OPERATOR, projectKey, environmentKey, 'vehicles'),
    Order: 2,
    Permissions: [{
      Action: 'Query',
      Name: 'Vehicle',
      Prefix: 'Portal',
      UserType: 'Operator'
    }]
  }, {
    Name: 'Members',
    Icon: menuIcons.menuIconUsers,
    External: linkIsExternal(projectKeys.AD_OPERATOR, projectKey),
    Path: getPath(projectKeys.AD_OPERATOR, projectKey, environmentKey, 'operatorMembers'),
    Order: 3,
    Permissions: [{
      Action: 'Query',
      Name: 'AutoAcceptMembersMenu',
      Prefix: 'Portal',
      UserType: 'Operator'
    }]
  }, {
    Name: 'Manage',
    Icon: menuIcons.menuIconUsers,
    External: false,
    Removable: false,
    Order: 4,
    SubItems: [{
      Name: 'Operator Profile',
      Icon: menuIcons.menuIconCog,
      External: linkIsExternal(projectKeys.AD_OPERATOR, projectKey),
      Path: getPath(projectKeys.AD_OPERATOR, projectKey, environmentKey, 'operatorProfile'),
      Removable: false,
      Order: 0,
      Permissions: [{
        Action: 'Query',
        Name: 'ExtendedPropertyDescription',
        Prefix: 'Portal',
        UserType: 'Operator'
      }]
    }]
  }];
};

/**
 * 
 * @param {string} projectKey = LEV, AD, 
 */
var getMenu = function getMenu(projectKey, environmentKey) {
  projectKey = projectKey.toUpperCase();
  environmentKey = environmentKey.toUpperCase();

  if (areaKeys[projectKey] === 'ADMINISTRATOR') {
    return getAdminMenu(projectKey, environmentKey);
  }

  if (areaKeys[projectKey] === 'OPERATOR') {
    return getOperatorMenu(projectKey, environmentKey);
  }
  return [];
};
// CONCATENATED MODULE: ./index.js








var veyobarVersion = '11.0.0';
var headerRoot = void 0;
var sidebarRoot = void 0;

// default side menu to open
if (localStorage.getItem('sideMenuOpen') === null) {
  localStorage.setItem('sideMenuOpen', true);
}

var initializeOpenedMenuItems = function initializeOpenedMenuItems() {
  var openedMenuItems = { items: ["Rescue Dispatch"], subItems: [] };
  var savedOpenedMenuItems = JSON.parse(localStorage.getItem('openedMenuItems'));
  if (!!savedOpenedMenuItems) {
    openedMenuItems = savedOpenedMenuItems;
  }

  localStorage.setItem('openedMenuItems', JSON.stringify(openedMenuItems));
  return openedMenuItems;
};

var index_state = {
  account: null,
  activatedPath: { item: "Rescue Dispatch", subItem: "Trips in OnDemand", finalItem: null },
  appVersions: [{ name: "Veyobar", version: veyobarVersion, environment: "" }],
  area: 'ADMINISTRATOR',
  logoUrl: "",
  logoutCallbackWrapper: null,
  menu: [],
  navigationCallback: null,
  removeMenuItemCallback: null,
  openedMenuItems: initializeOpenedMenuItems(),
  profileMenuOpen: false,
  sideMenuOpen: localStorage.getItem('sideMenuOpen') === 'true',
  versionMenuOpen: false,
  veyobarVersion: veyobarVersion
};

var initializeAccount = function initializeAccount() {
  var account = null;

  var savedAdminAccount = JSON.parse(localStorage.getItem('veyobarAccount_Administrator'));
  var savedOperatorAccount = JSON.parse(localStorage.getItem('veyobarAccount_Operator'));

  if (!!savedAdminAccount && index_state.area && index_state.area.toUpperCase() === 'ADMINISTRATOR') {
    account = savedAdminAccount;
  }

  if (!!savedOperatorAccount && index_state.area && index_state.area.toUpperCase() === 'OPERATOR') {
    account = savedOperatorAccount;
  }

  return account;
};

var updateArea = function updateArea(area) {
  index_state.area = area.toUpperCase();
  index_state.account = initializeAccount();
  console.log('update area', index_state.account, index_state.account ? index_state.account.Name : '');
  index_renderApp();
};

index_state.account = initializeAccount();

// removes a removable menu item
var removeMenuItem = function removeMenuItem(item) {
  var itemName = index_state.menu[item.quickAccess[0]].Name;
  var subItemName = null;
  var finalItemName = null;

  if (item.quickAccess.length === 1) {
    index_state.menu.splice(item.quickAccess[0], 1);
  }
  if (item.quickAccess.length === 2) {
    subItemName = index_state.menu[item.quickAccess[0]].SubItems[item.quickAccess[1]].Name;
    index_state.menu[item.quickAccess[0]].SubItems.splice(item.quickAccess[1], 1);
  }
  if (item.quickAccess.length === 3) {
    subItemName = index_state.menu[item.quickAccess[0]].SubItems[item.quickAccess[1]].Name;
    finalItemName = index_state.menu[item.quickAccess[0]].SubItems[item.quickAccess[1]].FinalItems[item.quickAccess[2]].Name;
    index_state.menu[item.quickAccess[0]].SubItems[item.quickAccess[1]].FinalItems.splice(item.quickAccess[2], 1);
  }

  // callback to tell app which menu item was removed
  if (!!index_state.removeMenuItemCallback) {
    index_state.removeMenuItemCallback(itemName, subItemName, finalItemName);
  }

  setCustomNavigationMenu(index_state.menu);
};

var index_setDefaultMenu = function setDefaultMenu(projectKey, environmentKey) {
  var existingMenu = localStorage.getItem('sideMenu');
  if (!existingMenu) {
    index_state.menu = getMenu(projectKey, environmentKey);
  } else {
    index_state.menu = JSON.parse(existingMenu);
  }
  index_renderApp();
};

var logoutCallbackWrapper = function logoutCallbackWrapper() {
  localStorage.removeItem('openedMenuItems');
  localStorage.removeItem('sideMenuOpen');
  localStorage.removeItem('sideMenu');
  localStorage.removeItem('veyobarAccount_Administrator');
  localStorage.removeItem('veyobarAccount_Operator');

  index_state.logoutCallback();
  toggleProfileMenu();
};

// set the navigation menu items from a JSON object in the specified file
var setCustomNavigationMenu = function setCustomNavigationMenu(menu) {
  index_state.menu = menu;
  localStorage.setItem('sideMenu', JSON.stringify(menu));
  index_renderApp();
};

// get the navigation menu JSON
var getNavigationMenu = function getNavigationMenu() {
  return index_state.menu;
};

// Toggle the sidebar (menu)
var toggleMenu = function toggleMenu() {
  index_state.sideMenuOpen = !index_state.sideMenuOpen;
  index_state.versionMenuOpen = false;
  localStorage.setItem('sideMenuOpen', index_state.sideMenuOpen);
  index_renderApp();
};

// Toggle the version menu
var toggleVersionMenu = function toggleVersionMenu() {
  index_state.versionMenuOpen = !index_state.versionMenuOpen;
  index_renderApp();
};

// Toggle the profile menu
var toggleProfileMenu = function toggleProfileMenu() {
  index_state.profileMenuOpen = !index_state.profileMenuOpen;
  index_renderApp();
};

// Expand or collapse a sidebar menu item
var toggleMenuItem = function toggleMenuItem(item) {
  var itemIndex = index_state.openedMenuItems.items.indexOf(item);
  if (itemIndex < 0) {
    index_state.openedMenuItems.items.push(item);
  } else {
    index_state.openedMenuItems.items.splice(itemIndex, 1);
  }
  localStorage.setItem('openedMenuItems', JSON.stringify(index_state.openedMenuItems));
  index_renderApp();
};

// Expand or collapse a sidebar sub menu item
var toggleMenuSubItem = function toggleMenuSubItem(item) {
  var itemIndex = index_state.openedMenuItems.subItems.indexOf(item);
  if (itemIndex < 0) {
    index_state.openedMenuItems.subItems.push(item);
  } else {
    index_state.openedMenuItems.subItems.splice(itemIndex, 1);
  }
  localStorage.setItem('openedMenuItems', JSON.stringify(index_state.openedMenuItems));
  index_renderApp();
};

// Set a sidebar menu link showing in active status, as if the user is visiting that page
// Every menu item the link is nested under will expand to show this link
var setPathActive = function setPathActive(item, subItem, finalItem) {
  index_state.activatedPath = { item: item, subItem: subItem, finalItem: finalItem };

  // make sure item is open
  if (index_state.openedMenuItems.items.indexOf(item) < 0) {
    toggleMenuItem(item);
  }

  // make sure sub item is open
  if (index_state.openedMenuItems.subItems.indexOf(subItem) < 0) {
    toggleMenuSubItem(subItem);
  }

  index_renderApp();
};

var headerSelector = function headerSelector(state) {
  return {
    account: state.account,
    toggleMenu: toggleMenu,
    toggleProfileMenu: toggleProfileMenu,
    sideMenuOpen: state.sideMenuOpen,
    profileMenuOpen: state.profileMenuOpen,
    logoutCallbackWrapper: logoutCallbackWrapper
  };
};

var setAppVersion = function setAppVersion(name, version, environment) {
  var index = index_state.appVersions.findIndex(function (item) {
    return item.name === name;
  });
  if (index < 0) {
    index_state.appVersions.push({ name: name, version: version, environment: environment });
  } else {
    index_state.appVersions[index] = { name: name, version: version, environment: environment };
  }
  index_renderApp();
};

var sidebarSelector = function sidebarSelector(state) {
  var _ref;

  return _ref = {
    account: state.account,
    activatedPath: state.activatedPath,
    appVersions: state.appVersions,
    authToken: state.authToken,
    logoUrl: state.logoUrl,
    menu: state.menu,
    navigationCallback: state.navigationCallback,
    removeMenuItemCallback: state.removeMenuItemCallback,
    openedMenuItems: state.openedMenuItems,
    removeMenuItem: removeMenuItem,
    setPathActive: setPathActive,
    sideMenuOpen: state.sideMenuOpen
  }, _ref['sideMenuOpen'] = state.sideMenuOpen, _ref.toggleMenuItem = toggleMenuItem, _ref.toggleMenuSubItem = toggleMenuSubItem, _ref.toggleVersionMenu = toggleVersionMenu, _ref.versionMenuOpen = state.versionMenuOpen, _ref.veyobarVersion = veyobarVersion, _ref;
};

var hideHeaderAndAdjustRootSize = function hideHeaderAndAdjustRootSize() {
  document.getElementById("veyobar-header").className = 'hidden';
  document.getElementById("veyobar-main").className = 'header-hidden';
  document.getElementById("veyo-root").className = 'header-hidden';
};
var hideSidebar = function hideSidebar() {
  document.getElementById("veyobar-sidebar").className = 'hidden';
  document.getElementById("veyo-root").className = 'sidebar-collapsed';
};
var showHeaderAndAdjustRootSize = function showHeaderAndAdjustRootSize() {
  document.getElementById("veyobar-header").className = '';
  document.getElementById("veyobar-main").className = '';
};
var showSidebar = function showSidebar() {
  document.getElementById("veyobar-sidebar").className = 'showing';
  document.getElementById("veyo-root").className = 'sidebar-open';
};

var index_renderApp = function renderApp() {
  index_state.sideMenuOpen ? showSidebar() : hideSidebar();
  showHeaderAndAdjustRootSize();
  headerRoot = Object(preact_min["render"])(Object(preact_min["h"])(header_Header, headerSelector(index_state)), document.getElementById("veyobar-header"), headerRoot);
  sidebarRoot = Object(preact_min["render"])(Object(preact_min["h"])(sidebar_Sidebar, sidebarSelector(index_state)), document.getElementById("veyobar-sidebar"), sidebarRoot);
};

function setAccount(account) {
  index_state.account = account;
  if (account && account.Role && account.Role.Name && account.Role.Name === 'Administrator') {
    localStorage.setItem('veyobarAccount_Administrator', JSON.stringify(account));
  }

  if (account && account.Role && account.Role.Name && account.Role.Name === 'Operator') {
    localStorage.setItem('veyobarAccount_Operator', JSON.stringify(account));
  }
  index_renderApp();
}

function update(key, value) {
  index_state[key] = value;
  index_renderApp();
}

window.veyobarspace = { renderApp: index_renderApp, update: update, setPathActive: setPathActive, setCustomNavigationMenu: setCustomNavigationMenu, getNavigationMenu: getNavigationMenu, setDefaultMenu: index_setDefaultMenu, setAppVersion: setAppVersion, setAccount: setAccount, updateArea: updateArea };

/***/ }),

/***/ "KCLY":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("cGG2");
var normalizeHeaderName = __webpack_require__("5VQ+");

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = __webpack_require__("7GwW");
  } else if (typeof process !== 'undefined' && Object.prototype.toString.call(process) === '[object process]') {
    // For node use HTTP adapter
    adapter = __webpack_require__("7GwW");
  }
  return adapter;
}

var defaults = {
  adapter: getDefaultAdapter(),

  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Accept');
    normalizeHeaderName(headers, 'Content-Type');
    if (utils.isFormData(data) || utils.isArrayBuffer(data) || utils.isBuffer(data) || utils.isStream(data) || utils.isFile(data) || utils.isBlob(data)) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }
    if (utils.isObject(data)) {
      setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
      return JSON.stringify(data);
    }
    return data;
  }],

  transformResponse: [function transformResponse(data) {
    /*eslint no-param-reassign:0*/
    if (typeof data === 'string') {
      try {
        data = JSON.parse(data);
      } catch (e) {/* Ignore */}
    }
    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,
  maxBodyLength: -1,

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  }
};

defaults.headers = {
  common: {
    'Accept': 'application/json, text/plain, */*'
  }
};

utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});

module.exports = defaults;

/***/ }),

/***/ "NffV":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Oi+a":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isAbsoluteURL = __webpack_require__("dIwP");
var combineURLs = __webpack_require__("qRfI");

/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 * @returns {string} The combined full path
 */
module.exports = function buildFullPath(baseURL, requestedURL) {
  if (baseURL && !isAbsoluteURL(requestedURL)) {
    return combineURLs(baseURL, requestedURL);
  }
  return requestedURL;
};

/***/ }),

/***/ "TNV1":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("cGG2");

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
module.exports = function transformData(data, headers, fns) {
  /*eslint no-param-reassign:0*/
  utils.forEach(fns, function transform(fn) {
    data = fn(data, headers);
  });

  return data;
};

/***/ }),

/***/ "XmWM":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("cGG2");
var buildURL = __webpack_require__("DQCr");
var InterceptorManager = __webpack_require__("fuGk");
var dispatchRequest = __webpack_require__("xLtR");
var mergeConfig = __webpack_require__("DUeU");

/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios.prototype.request = function request(config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof config === 'string') {
    config = arguments[1] || {};
    config.url = arguments[0];
  } else {
    config = config || {};
  }

  config = mergeConfig(this.defaults, config);

  // Set config.method
  if (config.method) {
    config.method = config.method.toLowerCase();
  } else if (this.defaults.method) {
    config.method = this.defaults.method.toLowerCase();
  } else {
    config.method = 'get';
  }

  // Hook up interceptors middleware
  var chain = [dispatchRequest, undefined];
  var promise = Promise.resolve(config);

  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    chain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    chain.push(interceptor.fulfilled, interceptor.rejected);
  });

  while (chain.length) {
    promise = promise.then(chain.shift(), chain.shift());
  }

  return promise;
};

Axios.prototype.getUri = function getUri(config) {
  config = mergeConfig(this.defaults, config);
  return buildURL(config.url, config.params, config.paramsSerializer).replace(/^\?/, '');
};

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function (url, config) {
    return this.request(mergeConfig(config || {}, {
      method: method,
      url: url,
      data: (config || {}).data
    }));
  };
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function (url, data, config) {
    return this.request(mergeConfig(config || {}, {
      method: method,
      url: url,
      data: data
    }));
  };
});

module.exports = Axios;

/***/ }),

/***/ "cGG2":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__("JP+z");

/*global toString:true*/

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return toString.call(val) === '[object Array]';
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is a Buffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Buffer, otherwise false
 */
function isBuffer(val) {
  return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor) && typeof val.constructor.isBuffer === 'function' && val.constructor.isBuffer(val);
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
function isArrayBuffer(val) {
  return toString.call(val) === '[object ArrayBuffer]';
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(val) {
  return typeof FormData !== 'undefined' && val instanceof FormData;
}

/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if (typeof ArrayBuffer !== 'undefined' && ArrayBuffer.isView) {
    result = ArrayBuffer.isView(val);
  } else {
    result = val && val.buffer && val.buffer instanceof ArrayBuffer;
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && typeof val === 'object';
}

/**
 * Determine if a value is a plain Object
 *
 * @param {Object} val The value to test
 * @return {boolean} True if value is a plain Object, otherwise false
 */
function isPlainObject(val) {
  if (toString.call(val) !== '[object Object]') {
    return false;
  }

  var prototype = Object.getPrototypeOf(val);
  return prototype === null || prototype === Object.prototype;
}

/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
function isDate(val) {
  return toString.call(val) === '[object Date]';
}

/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
function isFile(val) {
  return toString.call(val) === '[object File]';
}

/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
function isBlob(val) {
  return toString.call(val) === '[object Blob]';
}

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
  return toString.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
function isURLSearchParams(val) {
  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.replace(/^\s*/, '').replace(/\s*$/, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 */
function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && (navigator.product === 'ReactNative' || navigator.product === 'NativeScript' || navigator.product === 'NS')) {
    return false;
  }
  return typeof window !== 'undefined' && typeof document !== 'undefined';
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge() /* obj1, obj2, obj3, ... */{
  var result = {};
  function assignValue(val, key) {
    if (isPlainObject(result[key]) && isPlainObject(val)) {
      result[key] = merge(result[key], val);
    } else if (isPlainObject(val)) {
      result[key] = merge({}, val);
    } else if (isArray(val)) {
      result[key] = val.slice();
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 * @return {string} content value without BOM
 */
function stripBOM(content) {
  if (content.charCodeAt(0) === 0xFEFF) {
    content = content.slice(1);
  }
  return content;
}

module.exports = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isPlainObject: isPlainObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  extend: extend,
  trim: trim,
  stripBOM: stripBOM
};

/***/ }),

/***/ "cWxy":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Cancel = __webpack_require__("dVOP");

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */
function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;
  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });

  var token = this;
  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new Cancel(message);
    resolvePromise(token.reason);
  });
}

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};

/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

module.exports = CancelToken;

/***/ }),

/***/ "dIwP":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */

module.exports = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return (/^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url)
  );
};

/***/ }),

/***/ "dVOP":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */

function Cancel(message) {
  this.message = message;
}

Cancel.prototype.toString = function toString() {
  return 'Cancel' + (this.message ? ': ' + this.message : '');
};

Cancel.prototype.__CANCEL__ = true;

module.exports = Cancel;

/***/ }),

/***/ "fuGk":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("cGG2");

function InterceptorManager() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager.prototype.use = function use(fulfilled, rejected) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager.prototype.forEach = function forEach(fn) {
  utils.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

module.exports = InterceptorManager;

/***/ }),

/***/ "jKqc":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "mtWM":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("tIFN");

/***/ }),

/***/ "oJlt":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("cGG2");

// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var ignoreDuplicateOf = ['age', 'authorization', 'content-length', 'content-type', 'etag', 'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since', 'last-modified', 'location', 'max-forwards', 'proxy-authorization', 'referer', 'retry-after', 'user-agent'];

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
module.exports = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) {
    return parsed;
  }

  utils.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils.trim(line.substr(0, i)).toLowerCase();
    val = utils.trim(line.substr(i + 1));

    if (key) {
      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
        return;
      }
      if (key === 'set-cookie') {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
      }
    }
  });

  return parsed;
};

/***/ }),

/***/ "p1b6":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("cGG2");

module.exports = utils.isStandardBrowserEnv() ?

// Standard browser envs support document.cookie
function standardBrowserEnv() {
  return {
    write: function write(name, value, expires, path, domain, secure) {
      var cookie = [];
      cookie.push(name + '=' + encodeURIComponent(value));

      if (utils.isNumber(expires)) {
        cookie.push('expires=' + new Date(expires).toGMTString());
      }

      if (utils.isString(path)) {
        cookie.push('path=' + path);
      }

      if (utils.isString(domain)) {
        cookie.push('domain=' + domain);
      }

      if (secure === true) {
        cookie.push('secure');
      }

      document.cookie = cookie.join('; ');
    },

    read: function read(name) {
      var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
      return match ? decodeURIComponent(match[3]) : null;
    },

    remove: function remove(name) {
      this.write(name, '', Date.now() - 86400000);
    }
  };
}() :

// Non standard browser env (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
  return {
    write: function write() {},
    read: function read() {
      return null;
    },
    remove: function remove() {}
  };
}();

/***/ }),

/***/ "pBtG":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};

/***/ }),

/***/ "pxG4":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */

module.exports = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};

/***/ }),

/***/ "qRfI":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */

module.exports = function combineURLs(baseURL, relativeURL) {
  return relativeURL ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '') : baseURL;
};

/***/ }),

/***/ "t8qj":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */

module.exports = function enhanceError(error, config, code, request, response) {
  error.config = config;
  if (code) {
    error.code = code;
  }

  error.request = request;
  error.response = response;
  error.isAxiosError = true;

  error.toJSON = function toJSON() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: this.config,
      code: this.code
    };
  };
  return error;
};

/***/ }),

/***/ "tIFN":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("cGG2");
var bind = __webpack_require__("JP+z");
var Axios = __webpack_require__("XmWM");
var mergeConfig = __webpack_require__("DUeU");
var defaults = __webpack_require__("KCLY");

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind(Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, Axios.prototype, context);

  // Copy context to instance
  utils.extend(instance, context);

  return instance;
}

// Create the default instance to be exported
var axios = createInstance(defaults);

// Expose Axios class to allow class inheritance
axios.Axios = Axios;

// Factory for creating new instances
axios.create = function create(instanceConfig) {
  return createInstance(mergeConfig(axios.defaults, instanceConfig));
};

// Expose Cancel & CancelToken
axios.Cancel = __webpack_require__("dVOP");
axios.CancelToken = __webpack_require__("cWxy");
axios.isCancel = __webpack_require__("pBtG");

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};
axios.spread = __webpack_require__("pxG4");

module.exports = axios;

// Allow use of default import syntax in TypeScript
module.exports.default = axios;

/***/ }),

/***/ "uXl7":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _preact = __webpack_require__("EBst");

if (false) {
	require('preact/devtools');
} else if (false) {
	navigator.serviceWorker.register(__webpack_public_path__ + 'sw.js');
}

var interopDefault = function interopDefault(m) {
	return m && m.default ? m.default : m;
};

var app = interopDefault(__webpack_require__("JkW7"));

if (typeof app === 'function') {
	var root = document.body.firstElementChild;

	var init = function init() {
		var app = interopDefault(__webpack_require__("JkW7"));
		root = (0, _preact.render)((0, _preact.h)(app), document.body, root);
	};

	if (false) module.hot.accept('preact-cli-entrypoint', init);

	init();
}

/***/ }),

/***/ "xLtR":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("cGG2");
var transformData = __webpack_require__("TNV1");
var isCancel = __webpack_require__("pBtG");
var defaults = __webpack_require__("KCLY");

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
module.exports = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData(config.data, config.headers, config.transformRequest);

  // Flatten headers
  config.headers = utils.merge(config.headers.common || {}, config.headers[config.method] || {}, config.headers);

  utils.forEach(['delete', 'get', 'head', 'post', 'put', 'patch', 'common'], function cleanHeaderConfig(method) {
    delete config.headers[method];
  });

  var adapter = config.adapter || defaults.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData(response.data, response.headers, config.transformResponse);

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData(reason.response.data, reason.response.headers, config.transformResponse);
      }
    }

    return Promise.reject(reason);
  });
};

/***/ })

/******/ });


// WEBPACK FOOTER //
// bundle.069f8.js